import React from 'react';
import { useT } from '@repo/common';
import { USER_COLUMN_CLASS } from './userColumns';

const HeaderItem = ({ children, className, type }) => {
  return (
    <div
      className={`flex justify-center items-center text-center px-1 py-4 gap-[10px] relative z-10 ${className}`}
    >
      <span
        className={
          type === 'date'
            ? 'typo-b12 text-text-disable'
            : 'typo-b13Strong text-text-secondary'
        }
      >
        {children}
      </span>
    </div>
  );
};

/* 표 머리글은 tabletV(1180px) 이상에서만 보인다. 그 아래는 행이 카드로 바뀌어 머리글이 필요 없다. */
const UserListHeader = () => {
  const t = useT();
  return (
    <div className='hidden tabletV:flex flex-col w-full items-start px-2 bg-grayscale-gray02/30 rounded-t-[30px]'>
      <div className='flex w-full'>
        <HeaderItem className={USER_COLUMN_CLASS.joined} type='date'>
          {t('Joined', '가입일')}
        </HeaderItem>
        <HeaderItem className={USER_COLUMN_CLASS.id}>{t('ID', 'ID')}</HeaderItem>
        <HeaderItem className={USER_COLUMN_CLASS.name}>{t('Name', '이름')}</HeaderItem>
        <HeaderItem className={USER_COLUMN_CLASS.email}>{t('Email', '이메일')}</HeaderItem>
        <HeaderItem className={USER_COLUMN_CLASS.type}>
          {t('Account type', '계정 유형')}
        </HeaderItem>
        <HeaderItem className={USER_COLUMN_CLASS.lastLogin} type='date'>
          {t('Last login', '최근 로그인')}
        </HeaderItem>
        <div className={`flex justify-center items-center px-0.5 ${USER_COLUMN_CLASS.options}`} />
      </div>
      <div className='bg-grayscale-gray02/70 h-5' />
    </div>
  );
};

export default UserListHeader;
